var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('md-dialog',{attrs:{"closable":false,"btns":_vm.btns},model:{value:(_vm.accountVisible),callback:function ($$v) {_vm.accountVisible=$$v},expression:"accountVisible"}},[_vm._v(" "+_vm._s(_vm.message)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }